import script from "./HomeFooter.vue?vue&type=script&setup=true&lang=js"
export * from "./HomeFooter.vue?vue&type=script&setup=true&lang=js"

import "./HomeFooter.vue?vue&type=style&index=0&id=17a06ca7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-17a06ca7"]])

export default __exports__